import { useState } from 'react';
import {
  Button,
  ToolbarButton,
  Avatar,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  Divider,
} from '@fluentui/react-components';
import {
  Navigation24Regular,
  Settings24Regular,
  Person24Regular,
  SignOut24Regular,
} from '@fluentui/react-icons';
import { SettingsModal } from '@/components/common/SettingsModal';

interface HeaderProps {
  onMenuClick: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
    <>
    <header className="bg-white border-b border-gray-30 h-16 flex items-center px-6 shadow-2">
      <div className="flex items-center justify-between w-full">
        {/* Left Section */}
        <div className="flex items-center gap-4">
          <Button
            appearance="subtle"
            icon={<Navigation24Regular />}
            onClick={onMenuClick}
            aria-label="Toggle menu"
          />
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-salesforce-blue rounded flex items-center justify-center">
              <span className="text-white font-bold text-sm">R</span>
            </div>
            <h1 className="text-lg font-semibold text-gray-160">
              Retail Development Model
            </h1>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-2">
          <ToolbarButton
            appearance="subtle"
            icon={<Settings24Regular />}
            aria-label="Settings"
            onClick={() => setSettingsOpen(true)}
          />

          <Divider vertical className="h-8" />

          <Menu>
            <MenuTrigger disableButtonEnhancement>
              <Button
                appearance="subtle"
                icon={
                  <Avatar
                    size={32}
                    icon={<Person24Regular />}
                    color="brand"
                  />
                }
              />
            </MenuTrigger>
            <MenuPopover>
              <MenuList>
                <MenuItem icon={<Person24Regular />}>Profile</MenuItem>
                <MenuItem icon={<Settings24Regular />}>Settings</MenuItem>
                <Divider />
                <MenuItem icon={<SignOut24Regular />}>Sign Out</MenuItem>
              </MenuList>
            </MenuPopover>
          </Menu>
        </div>
      </div>
    </header>

    <SettingsModal isOpen={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </>
  );
}
